export const STOCK_ADJUSTMENT_REPORT_ACTION = ' STOCK_ADJUSTMENT_REPORT_ACTION '
export const STOCK_ADJUSTMENT_REPORT_SUCCESS = ' STOCK_ADJUSTMENT_REPORT_SUCCESS'

export const STOCK_ADJUSTMENT_REPORT_API_ERROR_ACTION = 'STOCK_ADJUSTMENT_REPORT_API_ERROR_ACTION'